export const ENTITY_DATA = 'entity-data';
export const ADD_ENTITY_DATA = 'add_entity-data';
export const EDIT_ENTITY_DATA = 'edit_entity-data';
export const DELETE_ENTITY_DATA = 'delete_entity-data';
export const METADATA = 'metadata';
export const UPDATE_METADATA = 'update_metadata';
export const EDIT_XDMCONTEXT_DATA = 'edit_xdmcontext-data';
export const DOCUMENT = 'document';
